var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStatusDeleted(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1C5.92487 1 1 5.92487 1 12C1 18.0752 5.92487 23 12 23C18.0752 23 23 18.0752 23 12C23 5.92487 18.0752 1 12 1ZM3 12C3 7.02943 7.02943 3 12 3C16.9705 3 21 7.02943 21 12C21 16.9705 16.9705 21 12 21C7.02943 21 3 16.9705 3 12Z",
    fill: "#222222",
    stroke: "#222222",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.46476 14.1211L8.46477 14.1211L14.1216 8.4643C14.5121 8.07373 15.1453 8.07377 15.5358 8.46427C15.9264 8.8548 15.9264 9.48797 15.5358 9.87849L9.87898 15.5353C9.87898 15.5353 9.87898 15.5353 9.87898 15.5353C9.48847 15.9258 8.85532 15.9258 8.46479 15.5353L8.46476 14.1211ZM8.46476 14.1211C8.07427 14.5116 8.07422 15.1448 8.46476 15.5353L8.46476 14.1211Z",
    fill: "#222222",
    stroke: "#222222",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87898 8.46428L9.7022 8.64105L9.87898 8.46428C9.48846 8.07376 8.85529 8.07376 8.46477 8.46428C8.07424 8.8548 8.07424 9.48797 8.46477 9.87849L8.46477 9.87849L14.1216 15.5353C14.1216 15.5353 14.1217 15.5353 14.1217 15.5353C14.5121 15.9258 15.1453 15.9258 15.5358 15.5353C15.9264 15.1448 15.9263 14.5116 15.5358 14.1211L9.87898 8.46428Z",
    fill: "#222222",
    stroke: "#222222",
    strokeWidth: 0.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusDeleted);
export default __webpack_public_path__ + "static/media/status-deleted.055fd88d.svg";
export { ForwardRef as ReactComponent };